import { useAppStore } from '@/store'
import { BrandLoader } from './BrandLoader'

/** Loader común de toda la app: animación de marca (efecto gooey).
 *  API estable (label/size/className). `size` conserva la semántica antigua (px del
 *  em base, default 12) y se escala al tamaño del SVG (~4.5×, para un footprint
 *  similar al spinner anterior). El color se adapta al tema (negro en claro,
 *  claro en oscuro). */
export function Loader({ label, size = 12, className = '' }: {
  label?: string
  size?: number
  className?: string
}) {
  const dark = useAppStore(s => s.dark)
  return (
    <BrandLoader
      label={label}
      size={Math.round(size * 4.5)}
      color={dark ? '#e5e7eb' : '#1d1d1b'}
      className={className}
    />
  )
}
